import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions} from '@aboutyou/tracking';
import React from 'react';

interface BrandTileTrackedProps {
  brand: Brand;
  position: number;
  className?: string;
}

export const BrandTileTracked: React.FC<
  React.PropsWithChildren<BrandTileTrackedProps>
> = ({brand, position, children, className}) => {
  return (
    <TrackPromotions
      className={className}
      trackingKey={brand.id}
      promotion={{
        brand,
        source: TrackingPromotionCreative.Brand,
        locationId: 'sub_brand',
      }}
      streamPosition={position}
      triggerOnce
    >
      {children}
    </TrackPromotions>
  );
};
